// extracted by mini-css-extract-plugin
export var chip = "_4g-0";
export var filterDropdown = "_4g-5";
export var filterItem = "_4g-6";
export var icon = "_4g-1";
export var removeButton = "_4g-3";
export var removeIcon = "_4g-4";
export var separator = "_4g-2";